import InlineEditors from '../../controllers/inlineEditors';

export default instance => {
  instance.ext.inlineEditors.attachEvent('onBeforeEditStart', ({ id, columnName }) => InlineEditors.onBeforeEditStart(id, columnName));
};
